import React from 'react';
import AddForm from '../../components/addForm/AddForm';

const Form = () => {
  return (
    <div className="post__wrapper">
      <AddForm />
    </div>
  )
};

export default Form;